module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step step--8"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Now to start your 7 day free trial")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("We’ll need a credit card to get started, but don’t worry. You can cancel anytime before the end of the trial.")])]), _vm._v(" "), _c('div', {
    ref: "payment",
    staticClass: "step__payment"
  }, [_c('p', {
    staticClass: "step__payment-title"
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('cardsIcon')], 1), _vm._v(" "), _c('div', {
    ref: "form",
    staticClass: "step__form"
  }, [_c('div', {
    staticClass: "step__form-block"
  }, [_c('InputField', {
    attrs: {
      "title": "NAME ON CARD",
      "type": "name",
      "placeholder": "Name",
      "autocomplete": "name",
      "autocapitalize": "words",
      "disabled": false,
      "errored": false,
      "validated": _vm.nameValid(_vm.cardName),
      "errorMessage": ""
    },
    model: {
      value: (_vm.cardName),
      callback: function($$v) {
        _vm.cardName = $$v
      },
      expression: "cardName"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('label', {
    staticClass: "input__label",
    attrs: {
      "for": "card"
    }
  }, [_vm._v("CARD INFO")]), _vm._v(" "), _c('div', {
    staticClass: "input__stripecard",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input__validate"
  }, [_c('p', [_vm._v(_vm._s(_vm.cardErrorMessage))])])])], 1)]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button button--full",
    class: {
      'button--disable': !this.isValid
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Start free trial")]), _vm._v(" "), _c('span', {
    staticClass: "button__subtitle"
  }, [_vm._v("\n                    You’ll be charged $1.00/month on " + _vm._s(_vm.weekFromNow()) + ".\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input",
    staticStyle: {
      "display": "none"
    }
  }, [_c('label', {
    staticClass: "input__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("NAME ON CARD")]), _vm._v(" "), _c('div', {
    staticClass: "input__block"
  }, [_c('input', {
    staticClass: "input__main",
    attrs: {
      "id": "name",
      "placeholder": "Name"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be7b37b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step5_CreditCard.vue
// module id = 545
// module chunks = 1